import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// IMPORTANT: This Firebase project is SHARED between fixit (client) and fixit2 (service provider)
// Both apps use the SAME Firebase project and database to enable interconnected functionality
// TODO: Replace with your actual Firebase config (use the SAME config as in fixit app)
const firebaseConfig = {
    apiKey: "AIzaSyBleAnPBGzpc4yH9fChB2Nmh-b1A-sxT8Y",
    authDomain: "skillhive-6600.firebaseapp.com",
    projectId: "skillhive-6600",
    storageBucket: "skillhive-6600.firebasestorage.app",
    messagingSenderId: "535174388656",
    appId: "1:535174388656:web:8ef433bad78f6792311475",
    measurementId: "G-2532TGT3Z6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
// Note: Google authentication is NOT enabled for this app
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
